export default __webpack_public_path__ + "static/media/leopard.ff9c831c.png";